import React, { useState, useEffect } from 'react';

//import Spinner from './Spinner';
import Plantilla from './plantillas/Plantilla'
import Button from "react-bootstrap/Button";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Modal from 'react-bootstrap/Modal';

import { SignOutButton } from './office365auth/SignOutButton';

import { getPaymentReference, getPaymentSSO, getSchedule, PortalError, windowOpen, isUserFromApp } from '../api/index'
import { getConfiguration } from '../api/config'
import { withPublicUrl } from '../helper/publicUrl'
import ErrorModal, { useErrorHandling } from './ErrorModal';
import Spinner from './Spinner';

const SiguientesPasos = ({ planAcademico }) => {
    const { error, clearError, showErrorModal } = useErrorHandling('PA005');
    const [showSpinner, setShowSpinner] = useState(false);
    //const handleSiguientesPasos = () => window.location.reload();

    const [showAcercateAServicios, setShowAcercateAServicios] = useState(false);
    useEffect(() => {
        if (!planAcademico) return false;
        if (planAcademico.estado.valor === 7) {
            setShowAcercateAServicios(true);
        }

    }, [planAcademico]);

    const executeWithSpinner = (func) => {
        setShowSpinner(true);

        func.then(res => res)
            .catch(err => handleError(err, '001'))
            .finally(() => setShowSpinner(false));
    };

    const handleError = (err, defaultNumber) => {
        const errEx = (err instanceof PortalError) ? { message: err.message, number: err.number } : { number: defaultNumber }
        showErrorModal(errEx.message, error.serie, errEx.number);
    };

    const handleGetPaymentReference = () => {
        return getPaymentReference(planAcademico);
    };

    const handleGetSchedule = () => {
        return getSchedule(planAcademico);
    };

    const handleGetPaymentSSO = () => {
        var func = getPaymentSSO(planAcademico)
            .then((link) => {
                if (!link) throw new PortalError("006", "Ocurrio un error al establecer la relacion de confianza con el portal de pagos. Por favor intenta nuevamente.<br /><br />Si el problema persiste contacta al administrador del sistema");

                if (isUserFromApp()) {
                    let encodedLink = btoa(link);
                    window.location.href = withPublicUrl(`/RedirectToPaymentPortal.html?link=${encodedLink}`);
                    return;
                }

                windowOpen(link);
            });

        executeWithSpinner(func);
    };

    return (<>
        <div className="container activacion siguientes-pasos">
            <Spinner show={showSpinner} />

            <ErrorModal error={error} onClose={clearError} />

            {showAcercateAServicios && <ModalAcercateAServiciosEscolares onClose={() => { setShowAcercateAServicios(false) }} />}

            <Plantilla id="SiguientesPasos" planInfo={planAcademico} />

            <Row className="mb-3 mt-4">
                <Col className="d-grid gap-2">
                    <Button className="custom-button" variant="link" size='sm' onClick={handleGetPaymentReference}>
                        <div>
                            Descarga tu ficha de pagos
                        </div>
                        <div>
                            <span className="material-symbols-outlined icon">download</span>
                        </div>
                    </Button>
                </Col>
            </Row>
            <Row className="mb-3 mt-4">
                <Col className="d-grid gap-2">
                    <Button className="custom-button" variant="link" size='sm' onClick={handleGetSchedule}>
                        <div>
                            Descarga tu horario de clase
                        </div>
                        <div>
                            <span className="material-symbols-outlined icon">download</span>
                        </div>
                    </Button>
                </Col>
            </Row>
            <Row className="mb-3 mt-4">
                <Col className="d-grid gap-2">
                    <AbrirPortalPagosButton caption="Accede a tu portal de pagos" onClick={handleGetPaymentSSO} />
                </Col>
            </Row>

            <Row>
                <Col className="d-grid gap-2">
                    <ModalInscribirMateriasAdicionales />
                </Col>
            </Row>

            <br className="mb-3 mt-4" style={{ marginBlock: "3em"} } />

            <Row className="mb-3 mt-4">
                <Col className="d-grid gap-2">
                    <AbrirConsultaButton planAcademico={planAcademico} />
                </Col>
            </Row>

            {/*<Row className="mb-3 mt-4">
                <Col className="d-grid gap-2">
                    <SignOutButton />
                </Col>
            </Row>*/}   
        </div>
    </>);
}


const AbrirPortalPagosButton = ({ caption, onClick }) => {
    const handleOnClick = () => { onClick() };
    caption = (!!caption) ? caption : "Quiero realizar un pago";

    return (<>
        <div className="d-grid gap-2">
            <Button className="custom-button" variant="link" size='sm' onClick={handleOnClick}>
                <div>
                    {caption}
                </div>
                <div>
                    <span className="material-symbols-outlined icon">launch</span>
                </div>
            </Button>
        </div>
    </>);
};


const AbrirConsultaButton = ({ caption, planAcademico }) => {
    const [performSignOut, setPerformSignOut] = useState(false);
    
    const handleOnClick = () => {
        const urlEncuesta = getConfiguration().encuestaSatisfaccionUrl.replace('{mat}', planAcademico.matricula);
        windowOpen(urlEncuesta);
        setPerformSignOut(true)
        //window.location = getConfiguration().encuestaSatisfaccionUrl;
    };
    caption = (!!caption) ? caption : "Continuar";

    return (<>
        <div className="d-grid gap-2">
            {performSignOut && <SignOutButton performSignOut={performSignOut} />}
            <Button variant="primary" onClick={handleOnClick}>
                <div>
                    {caption}
                </div>
            </Button>
        </div>
    </>);
};

const ModalInscribirMateriasAdicionales = () => {
    const [showModal, setShowModal] = useState(false);

    const handleClose = () => setShowModal(false);

    return (<>
        <div className="mb-3 mt-4">
            <strong>¿Quieres inscribir materias adicionales?</strong>
        </div>

        <Button className="custom-button" variant="link" size='sm' onClick={() => { setShowModal(true) }}>Ver más información sobre esto...</Button>

        <Modal size="lg" show={showModal} onHide={handleClose} style={{ height: "auto" }}>
            <Modal.Header closeButton>
                <Modal.Title><strong>Inscribir materias adicionales</strong></Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Row>
                    <Plantilla id="InscribirMateriasAdicionales"></Plantilla>
                </Row>
            </Modal.Body>
            <Modal.Footer>
                <Row style={{ display: "contents" }}>
                    <Col className="d-grid gap-2" >
                        <Button variant="primary" onClick={handleClose}>
                            Aceptar
                        </Button>
                    </Col>
                </Row>
            </Modal.Footer>
        </Modal>
    </>);
};


const ModalAcercateAServiciosEscolares = ({ onClose}) => {
    const handleClose = () => { onClose() };

    return (<>
        <Modal show={true} style={{ maxHeight: "100%", height: "auto" }}>
            {/*<Modal.Header closeButton>*/}
            {/*    <Modal.Title><strong>Acercate a serivicos escoalres</strong></Modal.Title>*/}
            {/*</Modal.Header>*/}
            <Modal.Body>
                <Row>
                    <Plantilla id="SiguientesPasos_AcercateAServiciosEscolares"></Plantilla>
                </Row>
            </Modal.Body>
            <Modal.Footer>
                <Row style={{ display: "contents" }}>
                    <Col className="d-grid gap-2" >
                        <Button variant="primary" onClick={handleClose}>
                            Aceptar
                        </Button>
                    </Col>
                </Row>
            </Modal.Footer>
        </Modal>
    </>);
};
export default SiguientesPasos;